export const DateConstants = {
  DATE_FORMAT: "M/D/YYYY",
  DATE_FORMAT_WITH_TIME: "M/D/YY - h:mm a",
  TIME_FORMAT: "h:mm a",
  SCHEDULE_DATE_FORMAT: "YYYY-MM-DD"
};
